export default __webpack_public_path__ + "static/media/1.2cc75d26.jpg";